export default {
  apiContactFormPostinId: '9b2bbe62-bbb3-4d44-8594-f43600defa44',
  name: 'Nome*',
  surname: 'Cognome*',
  phone: 'Telefono*',
  company: 'Azienda*',
  message: 'Messaggio*',
  sendRequest: 'Invia richiesta',
  termsExtLabel:
    'Ai sensi e per gli effetti del Reg. UE 2016/679 - GDPR: Acconsento al trattamento dei miei dati personali come da <a href="{url}" target="_blank">informativa sulla privacy</a>.',
  termsError: 'Accettare i termini e le condizioni',
  successPageTitle: 'Richiesta inviata con successo',
  successPageText:
    'Grazie per averci contattato. Ti risponderemo il prima possibile.',
  failurePageTitle: "Errore durante l'invio della richiesta",
  failurePageText:
    "Si è verificato un errore durante l'invio della richiesta. Per favore, riprova più tardi.",
  formIntro: '<b>Vuoi iniziare</b> un progetto?',
  formText:
    'Siamo felici di conoscerti! Compila il form sotto, ti ricontatteremo a breve.',
  policyChat:
    'ChatLGBTQ+ è un assistente virtuale basato su IA di SUNTIMES. Le risposte sono generate automaticamente e potrebbero contenere inesattezze.',
  chatPlaceholder: 'Cosa vuoi sapere?',
  // Trasparenza AI Act art. 50: dichiarazione obbligatoria al primo contatto.
  // Volutamente hardcoded e non gestita da DatoCMS per non poter essere rimossa.
  chatAiLabel: 'Assistente AI',
  chatAiDisclaimer:
    'Stai interagendo con un assistente virtuale basato su IA. Le risposte sono generate automaticamente e potrebbero contenere inesattezze.',
}
